import { render, staticRenderFns } from "./goodsIList.vue?vue&type=template&id=4a7f67b4&scoped=true"
import script from "./goodsIList.vue?vue&type=script&lang=js"
export * from "./goodsIList.vue?vue&type=script&lang=js"
import style0 from "./goodsIList.vue?vue&type=style&index=0&id=4a7f67b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a7f67b4",
  null
  
)

export default component.exports